/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1AccessLoginMutationRequest,
  PostApiV1AccessLoginMutationResponse,
  PostApiV1AccessLogin400,
  PostApiV1AccessLogin500,
} from "../../types/accessController/PostApiV1AccessLogin.ts";

function getPostApiV1AccessLoginUrl() {
  const res = { method: "POST", url: `/api/v1/access/login` as const };
  return res;
}

/**
 * @description Autentica um usuário e retorna um token.
 * @summary Realizar login no sistema
 * {@link /api/v1/access/login}
 */
export async function postApiV1AccessLogin(
  data: PostApiV1AccessLoginMutationRequest,
  config: Partial<RequestConfig<PostApiV1AccessLoginMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1AccessLoginMutationResponse,
    ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
    PostApiV1AccessLoginMutationRequest
  >({
    method: "POST",
    url: getPostApiV1AccessLoginUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
